import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import { Container, Dropdown, Header, Menu, Search } from "semantic-ui-react";
import { AuthContext } from "../../App";
import AuthService from "../../service/auth";
import CompanyRepo from "../../utils/repository/companyRepo";
import { CATEGORIES_ALLOWED_NON_ADMIN_USER_IDS, ROLES } from "../../constnats/user";
import CompanyUtils from "../../utils/companyUtils";
import { AssetUtils } from "../../utils/assetsUtils";
import CompanyLogo from "../company/companyLogo";
import NotificationBell from "../notifications";
import "./header.css"

const anonnymousClientsAllowed = process.env.REACT_APP_ANONYMOUS_CLIENTS_ALLOWED === "true"
const NON_PROD_ENV = process.env.REACT_APP_BACKEND_HOST !== 'https://backend.3d-stockpicker.com/'
//TODO: Export in a global variable in .env file

class HeaderMenu extends React.Component {


    render() {
        const rolesSet = AuthService.getGlobalRoles(this.context)
        const isAuthenticated = rolesSet.size() > 0
        const isEmployee = rolesSet.has(ROLES.EMPLOYEE)
        const isStandardizedLabelsManager = AuthService.hasAnyGlobalRole([ROLES.STANDARDIZED_LABELS_MANAGER_ROLE])
        const isQualityPolicyManager = AuthService.hasAnyGlobalRole([ROLES.QUALITY_REQUIREMENTS_POLICY_MANAGER_ROLE])
        const isCategoriesManager = AuthService.hasAnyGlobalRole([ROLES.CATEGORIES_MANAGER_ROLE])

        return (
            <Menu fixed="top" className={'siteHeader' + (NON_PROD_ENV ? ' green-color-header' : '')}>
                <Container>
                    <Menu.Item header className="noPadding">
                        <Link to="/"><AppLogo /></Link>
                    </Menu.Item>
                    {(isAuthenticated || anonnymousClientsAllowed) &&
                        <Menu.Item className="noBorder bold">
                            <Link to="/companies">Companies</Link>
                        </Menu.Item>}
                    <Menu.Menu position='right'>
                        {(isAuthenticated || anonnymousClientsAllowed) &&
                            <CompanySearch
                                publicOnly={!isEmployee}
                                urlPrefix={isEmployee ? "/admin" : ""} />}
                        {isEmployee && <AdministrationMenue
                            showStandardizedLabels={isStandardizedLabelsManager}
                            showCategories={isCategoriesManager}
                            showQualityPolicies={isQualityPolicyManager}
                            isAdmin={rolesSet.has(ROLES.ADMIN)} />}
                        {isAuthenticated && <NotificationBell />}
                        {isAuthenticated ?
                            <UserMenue /> :
                            <Menu.Item className="noBorder bold">
                                <Link to="/user/login">Log in</Link>
                            </Menu.Item>}
                    </Menu.Menu>
                </Container>
            </Menu >
        )
    }


}

function UserMenue() {
    return <>
        <Dropdown text={AuthService.getFullName()} pointing className='link item noBorder'>
            <Dropdown.Menu>
                <Dropdown.Item as={Link} to="/user/profile">Profile</Dropdown.Item>
                <Dropdown.Item as={Link} to="/user/changePassword">Change Password</Dropdown.Item>
                <Dropdown.Item onClick={() => AuthService.logout()}>Logout</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    </>
}

function AdministrationMenue({ isAdmin, showCategories, showStandardizedLabels, showQualityPolicies }:any) {
    return <>
        <Dropdown text="Administration" pointing className='link item noBorder'>
            <Dropdown.Menu>
                <Dropdown.Item as={Link} to="/admin/companies">Companies</Dropdown.Item>
                {(isAdmin || showCategories || CATEGORIES_ALLOWED_NON_ADMIN_USER_IDS.includes(AuthService.getUserId())) && 
                    <Dropdown.Item as={Link} to="/admin/categories">Categories</Dropdown.Item>
                }
                {(isAdmin || showStandardizedLabels) && (
                    <Dropdown.Item as={Link} to="/admin/standardized-labels">
                        Standardized Labels
                    </Dropdown.Item>
                )}
                {(isAdmin || showQualityPolicies) && (
                    <Dropdown.Item as={Link} to="/admin/quality-requirements-policies">
                        Quality Requirements Policies
                    </Dropdown.Item>
                )}
                <Dropdown.Item as={Link} to='/admin/tableUpdates'>Table Updates</Dropdown.Item>
                <Dropdown.Item as={Link} to='/admin/kpis'>KPIs</Dropdown.Item>
                <Dropdown.Item as={Link} to='/admin/tasks'>Tasks</Dropdown.Item>
                <Dropdown.Item as={Link} to='/notifications'>Notifications</Dropdown.Item>
                {isAdmin &&
                    <>
                    <Dropdown.Item as={Link} to='/admin/users'>Users</Dropdown.Item>
                    <Dropdown.Item as={Link} to='/admin/newsletter'>Newsletters</Dropdown.Item>
                    <Dropdown.Item as={Link} to='/admin/js-events'>JS Events</Dropdown.Item>
                        {/* <Dropdown.Item as={Link} to='/admin/activityLogs'>Activity Logs</Dropdown.Item> */}
                    <Dropdown.Item
                            href={process.env.REACT_APP_BACKEND_HOST + 'actuator/httptrace'}
                            position="right" >HTTP Trace</Dropdown.Item>
                    </>}
            </Dropdown.Menu>
        </Dropdown>
    </>
}

function AppLogo() {
    return <div className="appLogoWrapper">
        <span className="partOne">3D</span>
        <span className="partTwo">StockPicker</span>
        {/* <img src="/logo-s.png" style={{
            width: "199px",
            marginTop: "6px"
        }} /> */}
    </div>
}


function CompanySearch({ urlPrefix, publicOnly }:any) {
    const [companies, setCompanies] = React.useState([])
    const [value, setValue] = React.useState("")
    const [isLoading, setIsLoading] = React.useState(false)
    const navigate = useNavigate();

    const handleSearchChange = (e:any, { value }:any) => {
        setValue(value)
        if (value.length >= 1) {
            setIsLoading(true)
            CompanyRepo.search(value,(companies:any) => {
                setIsLoading(false)
                setCompanies(
                    companies
                        .filter((c: any) => (publicOnly ? c.visibility === 'PUBLIC' : true))
                        .map((c: any) => {
                            return {
                                title: CompanyUtils.getCompanyTitle(c),
                                id: c.id,
                                companyId: c.id,
                            };
                        }),
                );
            })
        }
    }

    const handleResultSelect = (e:any, data:any) => {
        navigate(urlPrefix + "/companies/" + data.result.id)
        setValue("")
    }

    return (
        <Search
            input={{ icon: 'search' }}
            loading={isLoading}
            onResultSelect={handleResultSelect}
            onSearchChange={handleSearchChange}
            results={companies}
            value={value}
            minCharacters={1}
            size="tiny"
            className="companySearch"
            resultRenderer={({ title, companyId }) => {
                return (
                    <div className="search-result-container">
                        <CompanyLogo className="search-result-image" companyId={Number(companyId)} />
                        <Header className="search-result-text" as="h5">
                            {title}
                        </Header>
                    </div>
                );
            }}
        />
    );
}

HeaderMenu.contextType = AuthContext;

export default HeaderMenu